export default {
  data() {
    return {}
  },
  create() {},
  methods: {
    async validateNum(e) {
      e = e || window.event
      if (
        (e.key >= 0 && e.key <= 9) ||
        (e.keyCode >= 96 && e.keyCode <= 105) ||
        e.keyCode === 8 ||
        e.keyCode === 9 ||
        e.keyCode === 13 ||
        e.keyCode === 46 ||
        e.keyCode === 37 ||
        e.keyCode === 39
      ) {
        return false
      } else {
        return e.preventDefault()
      }
    },
    async validateNum2(e) {
      let char = String.fromCharCode(e.keyCode)
      if (!/[^0-9]+/g.test(char)) {
        return true
      } else {
        e.preventDefault()
      }
    },
    async validateNumWithoutZero(e) {
      e = e || window.event
      if (
        (e.key > 0 && e.key <= 9) ||
        (e.keyCode >= 96 && e.keyCode <= 105) ||
        e.keyCode === 8 ||
        e.keyCode === 9 ||
        e.keyCode === 13 ||
        e.keyCode === 46 ||
        e.keyCode === 37 ||
        e.keyCode === 39
      ) {
        return false
      } else {
        return e.preventDefault()
      }
    },
    validateQty(event, input) {
      if (
        event.keyCode === 190 ||
        event.keyCode === 110 ||
        event.keyCode === 107 ||
        event.keyCode === 107 ||
        event.keyCode === 109 ||
        event.keyCode === 69 ||
        event.keyCode === 189 ||
        event.keyCode === 187 ||
        (input.length > 9 && event.keyCode !== 8)
      ) {
        return event.preventDefault()
      } else {
        return false
      }
    },
    validateAmount(event, input) {
      var getDecimal = input.split('.')[1]
      var defaultLength = 8
      if (input.includes('.')) {
        defaultLength = 11
        if (getDecimal.length > 1 && event.keyCode !== 8) {
          return event.preventDefault()
        }
      } else {
        if (event.keyCode === 110 || input.includes('.')) {
          defaultLength = 11
        }
        if (
          event.keyCode === 190 ||
          event.keyCode === 107 ||
          event.keyCode === 107 ||
          event.keyCode === 109 ||
          event.keyCode === 69 ||
          event.keyCode === 189 ||
          event.keyCode === 187 ||
          (input.length > defaultLength && event.keyCode !== 8)
        ) {
          return event.preventDefault()
        } else {
          return false
        }
      }
      console.log(getDecimal)
    },
    validateIsNumber(evt) {
      evt = evt || window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    validateEngish(evt) {
      evt = evt || window.event
      var letters = /^[A-Za-z]+$/
      return letters.test(evt)
    },
    validateDecimal(model, target, decimal) {
      if (target) {
        this.$data[model][target] = this.$data[model][target]
          .replace(/[^.\d]/g, '')
          .replace(/^(\d*\.?)|(\d*)\.?/g, '$1$2')
        if (
          this.$data[model][target].includes('.') &&
          this.$data[model][target].split('.')[1].length > decimal
        ) {
          this.$data[model][target] = this.$data[model][target].slice(0, -1)
        } else if (
          this.$data[model][target].includes('.') &&
          this.$data[model][target].length === 1
        ) {
          this.$data[model] = this.$data[model].slice(0, -1)
        }
        if (
          (this.$data[model].split('.')[0] === '00') |
          (this.$data[model][target] === '00')
        ) {
          this.$data[model][target] = 0
        }
      } else {
        this.$data[model] = this.$data[model]
          .replace(/[^.\d]/g, '')
          .replace(/^(\d*\.?)|(\d*)\.?/g, '$1$2')
        if (
          this.$data[model].includes('.') &&
          this.$data[model].split('.')[1].length > decimal
        ) {
          this.$data[model] = this.$data[model].slice(0, -1)
        } else if (
          this.$data[model].includes('.') &&
          this.$data[model].length === 1
        ) {
          this.$data[model] = this.$data[model].slice(0, -1)
        }
        if (
          (this.$data[model].split('.')[0] === '00') |
          (this.$data[model] === '00')
        ) {
          this.$data[model] = 0
        }
      }
    },
    validateDecimalWithModel(model, decimal, maximum) {
      model = model
        .replace(/[^.\d]/g, '')
        .replace(/^(\d*\.?)|(\d*)\.?/g, '$1$2')
      if (model.includes('.') && decimal === 0) {
        model = model.slice(0, -1)
      } else if (model.includes('.') && model.split('.')[1].length > decimal) {
        model = model.slice(0, -1)
      } else if (model.includes('.') && model.length === 1) {
        model = model.slice(0, -1)
      }
      if ((model.split('.')[0] === '00') | (model === '00')) {
        model = 0
      }
      if (model >= maximum) {
        model = model.slice(0, -1)
      }
      return model
    },
  },
}
